import React from "react";
import IconButton from "@material-ui/core/IconButton";
import { useStore } from "../../../context";
import { navigate } from "@reach/router";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import Badge from "@material-ui/core/Badge";
import Tooltip from "@material-ui/core/Tooltip";

//-------------------------------------------------------------------------
// Parte Superior de la pagina. Carrito
//-------------------------------------------------------------------------

const MenuHeader = (type) => {
  const { state } = useStore();

  const navegar = (type) => {
    try {
      if (type === "inscripciones") {
        navigate("/inscripcion/cartIns");
      } else if (type === "matricula") {
        navigate("/matricula/cartMat");
      } else {
        navigate("/pension/cart");
      }
    } catch (error) {}
  };

  const getCartLength = () => {
    if (type.type === "inscripciones") return state.cartIns.length;
    if (type.type === "matricula") return state.cartMat ? state.cartMat.length : 0;
    return state.cart.length;
  };

  return (
    <>
      <Tooltip title="Ver carrito">
        <IconButton style={{ color: "#fff" }} onClick={() => navegar(type.type)}>
          <Badge badgeContent={getCartLength()} color="secondary">
            <ShoppingCartIcon />
          </Badge>
        </IconButton>
      </Tooltip>
    </>
  );
};

export default MenuHeader;
